module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/headquarters/hq-grid-3-large-6e9a64eebba1da5e9855210af4924039.jpg";